import { render } from "./ButtonsToggle.vue?vue&type=template&id=c18bffec&scoped=true"
import script from "./ButtonsToggle.vue?vue&type=script&lang=js"
export * from "./ButtonsToggle.vue?vue&type=script&lang=js"

import "./ButtonsToggle.vue?vue&type=style&index=0&id=c18bffec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c18bffec"]])

export default __exports__